(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,2481,7138],{

/***/ 26518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ContentfulContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/** @public */
var ContentfulContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/** @public */
var ContentfulProvider = function (_a) {
    var contentful = _a.contentful, children = _a.children;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContentfulContext.Provider, { value: contentful }, children);
};
ContentfulProvider.displayName = 'ContentfulProvider';
ContentfulContext.displayName = 'ContentfulContext';
/* harmony default export */ __webpack_exports__["Z"] = (ContentfulProvider);
//# sourceMappingURL=ContentfulProvider.js.map

/***/ }),

/***/ 21643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "So": function() { return /* binding */ FeatureContext; }
/* harmony export */ });
/* unused harmony export FeatureConsumer */
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded=["features"];var FeatureContext=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();var FeatureConsumer=FeatureContext.Consumer;var FeatureProvider=function FeatureProvider(_ref){var features=_ref.features,props=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref,_excluded);return/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FeatureContext.Provider,(0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({value:features},props));};FeatureProvider.defaultProps={features:[]};FeatureProvider.propTypes={features:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)};/* harmony default export */ __webpack_exports__["ZP"] = (FeatureProvider);
//# sourceMappingURL=FeatureProvider.js.map

/***/ }),

/***/ 37138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ themeGet; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/object-assign.js
var object_assign = __webpack_require__(96086);
;// CONCATENATED MODULE: ./node_modules/@styled-system/core/dist/index.esm.js

var merge = function merge(a, b) {
  var result = assign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    assign(result, (_assign = {}, _assign[key] = assign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      assign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      assign(styles, style);
    } else {
      var _assign2;

      assign(styles, (_assign2 = {}, _assign2[media] = assign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      assign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      assign(styles, (_assign3 = {}, _assign3[media] = assign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    assign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

;// CONCATENATED MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js

var themeGet = function themeGet(path, fallback) {
  if (fallback === void 0) {
    fallback = null;
  }

  return function (props) {
    return get(props.theme, path, fallback);
  };
};
/* harmony default export */ var index_esm = ((/* unused pure expression or super */ null && (themeGet)));


/***/ }),

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(51498);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constants_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85968);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var _obj;
var BANNER_TEXT_VALUES = (_obj = {}, _defineProperty(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_0__/* .FLIGHT_PRODUCT_TYPE */ .oP, {
    titleText: 'Get the app. Save more.',
    contentText: 'Save up to 40% on flights with the app',
    pageId: 'MWEB_FLT_HP_HEADER'
}), _defineProperty(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_0__/* .HOME_PRODUCT_TYPE */ .Wn, {
    titleText: 'Get the app. Save more.',
    contentText: 'Get exclusive deals only in our app',
    pageId: 'MWEB_HTL_HP_HEADER'
}), _defineProperty(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_0__/* .HOTEL_PRODUCT_TYPE */ .kd, {
    titleText: 'Get the app. Save more.',
    contentText: 'Save up to 60% off hotels with the app',
    pageId: 'MWEB_HTL_HP_HEADER'
}), _obj);
/* harmony default export */ __webpack_exports__["Z"] = (BANNER_TEXT_VALUES);


/***/ }),

/***/ 29397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AppBanner; },
/* harmony export */   "getPropsForAppBanner": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_7__.we; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67113);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40869);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39997);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23720);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32680);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13326);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  background-color: #002f6b;\n  color: ",
        ";\n  padding: 10px;\n  @media (min-width: 400px) {\n    padding-right: 24px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  &:active,\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var COOKIE_MAX_AGE = 86400 // 24 hours
;
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4e27b706-0"
})(_templateObject(), (0,pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* .getPaletteColor */ .ow)('text.lightest'));
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4e27b706-1"
})(_templateObject1(), (0,pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* .getPaletteColor */ .ow)('text.lightest'));
var AppIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "57",
        height: "57",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("image", {
            width: "57",
            height: "57",
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAAByCAMAAAC4A3VPAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACtVBMVEUAAAAAqv8AeP8Aef8A d/8AeP8AeP8AeP8AeP8Amf8Ad/8Ad/8Ad/8Ajv8AeP8Aef8AeP8Aev8AeP8A//8Aef8AgP8AeP8A eP8Ad/8Ad/8AeP8Ae/8AeP8Ad/8Fef8Yg/8SgP+YyP+52f9Sov86lf////+92/8Hev+Iv/+82/9p r/+kzv/8/f8ojP+Au/9Inf/T5/9To/+v1P93tv/r9P8Ugf9cqP/4+/8rjf90tP8dhv9Cmv92tf8p jP8Wgv8wkP9iq/9HnP8Mff89l/8CeP8xkf8tj/8LfP8DeP8+mP+Nwv+DvP8Ie/8hiP9xs/+SxP+j zf+Lwf9Qof8Eef8kiv8vkP8chf9jq/96uP9Bmf9tsf+RxP+Owv9VpP8Gev+byf+w1P/1+f9krP80 kv+p0f/l8f+72v9Amf/Y6v/s9P9eqf8Ofv+gzP/j8P+Vxv9WpP94t//7/P/B3f8Pf/8KfP/+/v/o 8v+Fvf/5+//6/P/a6/8Je//F4P+Uxf+Mwf/9/f9Uo/+y1f9fqf+Pw//e7f/k8P+Txf+Xx//y+P+E vf/b6/9Em/+JwP/J4v/A3f/V6P9ztP/i7/9orv9Dmv+CvP/3+v8Vgv+lz/8Bd/+hzP8eh/9wsv/g 7v8qjf+q0f/z+P/u9f98uf9vsv/p8/8fh/8ni/8Tgf9mrf9Ln/+izf8bhf85lf+42f/2+v8sjv/H 4f8zkv/L4//n8v9usf9dqP/W6f+z1v8ahP/D3/9+uv/f7f/I4f+u0/8RgP/0+f+cyv9gqv+t0/8g iP9Zpv91tf+ayf+ey//X6f9ap//N5P81k/99uf/Z6v9Fm//U6P/t9f9GnP/M4/+Gvv8ZhP/w9/+s 0v+32P/G4P+o0P95t/8uj/8mi/9Jnf+Qw/9/uv9hqv9Knv+n0P/R5v++3P+Bu/84lP/Q5f+v8YJH AAAAHXRSTlMAAzVymsLf7PkFT6vwCXlj5EnVAYUMsCDS6aw2m/ImqpAAAAABYktHRCXDAckPAAAA B3RJTUUH5AUTDyklz1OIpAAABPBJREFUaN7tm4tbFFUUwGd3gcUFAXmpwGFVvFEGYlHaQwhiVQQl ZXmYGVmGkZaGgEKWlEZiJZWlkRqSmZZZGj3NB2CW9i572mt7/x2de2cfw+5l4MOZud/nN+f7ds65 95yd38yde8/sfnNGkjhisdrCwiPskTBiibRHhIfZrBZpWDLKERU9ctZAiY5yjBoSODrGrhVPFnvM aFWgJTZOWyCVuFiV8R0Trz2QSvyYQYAJifoAqSQm8IhJyfoRAZKTQoljx+lJBBg3NoQ4Xl8iwPgg ZpLO58jOc8DYJuh6HX2SrJxDOs5VpSQq1qMxRAD/+rTolAFCJd6Xh2KNIgLEejO5Dnl1MImTc3yM cUSAGHZ/1PhupS52ev90GEkEcCAyxVhkFK4QzX51DE+iLVKqsUQAq2QzGmmT0oxGpknhRiPDpQij kRGSoYmAil26gH8BI5NIyWgigIk0kSbSRJpIE2kiL1ZkutPpnKAtcsLESRlq/smEkEsAMi+9bIpW yMsJycoeGjkVVY5GyGm4ryuGRl6JKlcjJB7+VVcPjZxOyIxrNEJCxrXXqbm9SLh+5rCISmReXl4+ 3FCQW8im341FRUXZ4Jo1G2ajNYd2Fc/NLSnNmMeC55fdtGBhuVuBrMAwHIxKFKiqLl10s0vebdXi WxYsubWGi8Rv3rYUN+T2O7C1DI07p9eSEliOViX23FVHneTuFQAr72EmuXduALkK1WqALFT31VPn mgZ0Nq5qYpFrCwdBym5C1snIZvz4kTktXuf989Y/4DVJfY4f+WAA6ZUNuGYn+RqtD/GRhDy8cROC WioYkiiQNY+gant0c3vTLNiC5mPVjz+BB9HWwDnLrK0d9DyfBHgK1dPbnnl2O47ODj7yuU6AKaif l5FtC1fv9CJ34XZ3PsALXdC4h5BuNOFF7NvGQe5l85d0g/slvEz7MHIxNmfykS+jTm+nB0iR7ftp v4zswO0B2qyBV9B89SDKa2gc4iBxFqXjNXqduZbSyDfQOMxFdjNjDa4w1xFsvgkBZA9uq+TAt4hC aoOuJY5oEw1qpsi3lZF7uMh3mPEuWu9R5PsB5Bz6pWI5cJNyR6Q45Czr/cijAyIbeMgPmHEMDzQz COmmk9kpB5agebzaJ+6Qswwg6cU+5I9cz0O2nqBJ4CQuIwhCQi1uV8iBZWj2Mis7AziLJIDsw75+ FnnqQ9cgi6QU9WnUH7Hpo0R+jNszeEQrz0IlTRc70ZN5mHySAyoDuw/HpiUPW+7lZFo5H5m1pHxD K+plIchPaXfdZ3s/78mEfjR7dn1x4EvUR9WQ0IudX53+uvobOTNwU4EsXRAysHDO55wI337nj/ze BSrXEk6s9Uf+kM5PeD8y70+NHCScb2bOGec64eet8m5OlhWDKhJ+6ZAjty/yEYOnD/z6W+/vR2hr v8fj+YP1F6LFbi5V5/881j/1IDVdnuN/nfn7H5pYIB/9mGr/RXUKoK+goI/2bvR42GzrPNv1X13H uooAJxhpgJhI/ZH4C9hpMNIoMZEm0kSaSBN5cSEFPIAS8JhNwMNEAY9MDX8wHCbi8bfVaKRVRCmD gIINEWUpAopvBJQYiSikElAuJqIoTkDpn4gCRxFlnAKKVUWU5IooPBZRXi2iiFwSUCoviXghQBLw 2gMrXnWkaPdyR8owXu6QxzfVlnbhr7Ck2VK5I/o/Z+dDnvYkUfwAAAAldEVYdGRhdGU6Y3JlYXRl ADIwMjAtMDUtMTlUMTU6NDE6MzcrMDM6MDDubfKPAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTA1 LTE5VDE1OjQxOjM3KzAzOjAwnzBKMwAAAABJRU5ErkJggg=="
        })
    });
};
function AppBanner(param) {
    var isAndroid = param.isAndroid, titleText = param.titleText, contentText = param.contentText, pageId = param.pageId, referral = param.referral, clientGUID = param.clientGUID;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isBannerVisible = ref[0], setBannerVisible = ref[1];
    var closeAppBanner = function() {
        setBannerVisible(false);
        document.cookie = "hideAppBanner=true; domain=.priceline.com; path=/; max-age=".concat(COOKIE_MAX_AGE, ";");
    };
    return isBannerVisible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        id: "app-download-banner",
        className: "app-banner",
        fontSize: 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    size: 16,
                    id: "closeBannerBtn",
                    "data-ga-category": "PCLN_HOME",
                    "data-ga-action": "App_Banner",
                    "data-ga-label": "dismiss",
                    title: "dismiss app banner",
                    onClick: closeAppBanner
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledLink, {
                color: "text.lightest",
                href: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getLink */ .Rg)(isAndroid, referral, clientGUID, pageId),
                "data-testid": "DASH_MWEB_TAB_GET_APP",
                "data-ga-category": "PCLN_HOME",
                "data-ga-action": "App_Banner",
                "data-ga-label": "click to launch",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        alignItems: "flex-start",
                        px: 12,
                        py: 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppIcon, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                fontWeight: "bold",
                                fontSize: 15,
                                lineHeight: "19px",
                                mb: 1,
                                children: titleText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                fontSize: 13,
                                lineHeight: "12px",
                                children: contentText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        alignItems: "center",
                        ml: "auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            title: "click to launch app",
                            color: "text.lightest",
                            size: 20
                        })
                    })
                ]
            })
        ]
    }) : null;
};



/***/ }),

/***/ 13326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "Cx": function() { return /* binding */ shouldHideAppBanner; },
/* harmony export */   "we": function() { return /* binding */ getPropsForAppBanner; }
/* harmony export */ });
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69376);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57330);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58493);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72593);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24088);
/* harmony import */ var _shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27781);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var buildReferralData = function(isAndroid, referral) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        sourceId: '',
        id: 'DTAPPDL',
        clickId: isAndroid ? 'MWEBHPANDROID' : 'MWEBHPIOS'
    }, referral);
};
var baseUrlAndroid = 'https://www.priceline.com/r/app/';
var baseUrlNoAndroid = 'https://offers.priceline.com/lrapp/';
var getLink = function(isAndroid, referral, clientGUID, pageId) {
    var ref = buildReferralData(isAndroid, referral), id = ref.id, sourceId = ref.sourceId, _clickId = ref.clickId, clickId = _clickId === void 0 ? '' : _clickId;
    var queryStringObject = _objectSpread({
        channel: 'Display',
        product: 'App',
        theme: 'app_dl_install',
        refid: "".concat(sourceId).concat(id),
        refclickid: clickId,
        PAGEID: pageId
    }, clientGUID && {
        subSiteId: clientGUID
    });
    var baseUrl = isAndroid ? baseUrlAndroid : baseUrlNoAndroid;
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(baseUrl, '?'), (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('&', (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('='), (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(queryStringObject))));
};
var getTrafficInfo = function(query, referral) {
    var tmp = referral.id, _ckReferralId = tmp === void 0 ? '' : tmp, tmp1 = referral.clickId, cookieRefClickId = tmp1 === void 0 ? '' : tmp1, tmp2 = referral.sourceId, _ckRefSourceId = tmp2 === void 0 ? '' : tmp2;
    var cookieRefId = _ckRefSourceId.concat(_ckReferralId);
    var tmp3 = query.refid, _qsRefId = tmp3 === void 0 ? '' : tmp3, tmp4 = query.refclickid, _qsRefClickId = tmp4 === void 0 ? '' : tmp4;
    var queryRefId = typeof _qsRefId === 'string' && Object.keys(_qsRefId).length > 0 ? _qsRefId : '';
    var queryRefClickId = typeof _qsRefClickId === 'string' && Object.keys(_qsRefClickId).length > 0 ? _qsRefClickId : '';
    var isPaid = cookieRefId.indexOf('GOOGLECPC|MSN') > -1 || queryRefId.indexOf('GOOGLECPC|MSN') > -1;
    var isBranded = cookieRefClickId.indexOf('BRAND') > -1 || queryRefClickId.indexOf('BRAND') > -1;
    var excludedRefIds = [
        'PLHTLCOMBINED',
        'PLHBC10161OPQ'
    ];
    var isBlackListed = cookieRefId.indexOf('CO') === 0 || queryRefId.indexOf('CO') === 0 || excludedRefIds.indexOf(cookieRefId) > -1 || excludedRefIds.indexOf(queryRefId) > -1;
    return {
        isPaid: isPaid,
        isBranded: isBranded,
        isBlackListed: isBlackListed
    };
};
var shouldHideAppBanner = function(data, query) {
    var isCookieSetToHideAppBanner = data.isCookieSetToHideAppBanner, isMobile = data.isMobile, referral = data.referral;
    var ref = getTrafficInfo(query, referral), isPaid = ref.isPaid, isBranded = ref.isBranded, isBlackListed = ref.isBlackListed;
    return isCookieSetToHideAppBanner || (0,_shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(query) || !isMobile || isPaid && !isBranded || isBlackListed;
};
var getPropsForAppBanner = function(data) {
    var referral = data.referral, webstats = data.webstats, isMobile = data.isMobile, isAndroid = data.isAndroid;
    var ref;
    return {
        referral: referral !== null && referral !== void 0 ? referral : {},
        clientGUID: (ref = webstats === null || webstats === void 0 ? void 0 : webstats.clientGUID) !== null && ref !== void 0 ? ref : '',
        isMobile: isMobile,
        isAndroid: isAndroid
    };
};


/***/ }),

/***/ 85968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ CRUISE_PRODUCT_TYPE; },
/* harmony export */   "oP": function() { return /* binding */ FLIGHT_PRODUCT_TYPE; },
/* harmony export */   "Wn": function() { return /* binding */ HOME_PRODUCT_TYPE; },
/* harmony export */   "kd": function() { return /* binding */ HOTEL_PRODUCT_TYPE; },
/* harmony export */   "Jz": function() { return /* binding */ RENTAL_CAR_PRODUCT_TYPE; },
/* harmony export */   "nu": function() { return /* binding */ VACATION_PACKAGE_PRODUCT_TYPE; }
/* harmony export */ });
/* unused harmony export TRIPS_PRODUCT_TYPE */
var CRUISE_PRODUCT_TYPE = 'cruises';
var FLIGHT_PRODUCT_TYPE = 'flights';
var HOME_PRODUCT_TYPE = 'home';
var HOTEL_PRODUCT_TYPE = 'hotels';
var RENTAL_CAR_PRODUCT_TYPE = 'cars';
var TRIPS_PRODUCT_TYPE = 'trips';
var VACATION_PACKAGE_PRODUCT_TYPE = 'vacations';


/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useGA4AnalyticsForSETI; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/analytics/dist/esm/browser.js + 22 modules
var browser = __webpack_require__(45741);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(1377);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/constants/page-map.ts
var pageMap = {
    '/': 'homepage',
    '/hotels': 'landingpage',
    '/flights': 'landingpage',
    '/vacationpackages': 'landingpage',
    '/vip': 'vip'
};
function mapPage(page) {
    return pageMap[page];
};

;// CONCATENATED MODULE: ./src/constants/product-map.ts
var productMap = {
    '/': '',
    '/hotels': 'hotel',
    '/flights': 'air',
    '/vacationpackages': 'bundle',
    '/vip': '',
    vacations: 'bundle',
    hotels: 'hotel',
    flights: 'air',
    cars: 'car',
    cruises: 'cruise'
};
function mapProduct(product) {
    return productMap[product];
};

;// CONCATENATED MODULE: ./src/hooks/useRouteInfo.ts



function useRouteInfo() {
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query;
    var pageName = mapPage(pathname);
    var currentTab = (query === null || query === void 0 ? void 0 : query.tab) && !Array.isArray(query.tab) ? query.tab : undefined;
    var productName = currentTab ? mapProduct(currentTab) : mapProduct(pathname);
    return {
        pageName: pageName,
        productName: productName
    };
};

;// CONCATENATED MODULE: ./src/hooks/useGA4Analytics.ts




function isSuccessfulSetiResponse(fullSeti) {
    return fullSeti.length === 0 || fullSeti[0].setiID !== undefined && fullSeti[0].setiVariantID !== undefined;
}
function useGA4AnalyticsForSETI(experimentCode) {
    var fullSETI = (0,react.useContext)(BootstrapDataContext/* default */.Z).fullSETI;
    var routeInfo = useRouteInfo();
    var logGA4Event = (0,react.useCallback)(function() {
        var baseSETI;
        if (isSuccessfulSetiResponse(fullSETI)) baseSETI = fullSETI.find(function(seti) {
            return seti.setiTagName === experimentCode;
        });
        if (!(baseSETI === null || baseSETI === void 0 ? void 0 : baseSETI.setiID)) return;
        browser/* default.GA4Enabled */.Z.GA4Enabled = true;
        browser/* default.logEvent */.Z.logEvent({
            event: 'seti',
            attributes: {
                seti_id: baseSETI.setiID,
                seti_variant_id: baseSETI.setiVariantID,
                seti_name: experimentCode,
                page_name: routeInfo.pageName,
                product_name: routeInfo.productName
            }
        });
        browser/* default.GA4Enabled */.Z.GA4Enabled = false;
    }, [
        experimentCode,
        fullSETI,
        routeInfo
    ]);
    return {
        logGA4Event: logGA4Event
    };
};


/***/ }),

/***/ 22091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSeti; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80460);
/* harmony import */ var _context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93107);
/* harmony import */ var _useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70710);




function useSeti(experimentCode) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), tmp = ref[experimentCode], setiTest = tmp === void 0 ? 'DEFAULT' : tmp;
    var logGA4Event = (0,_useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(experimentCode).logGA4Event;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (experimentCode && shouldFireImpression) {
            _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireImpression */ .Z.fireImpression(experimentCode);
            logGA4Event();
        }
    }, [
        experimentCode,
        logGA4Event,
        shouldFireImpression
    ]);
    return setiTest;
};


/***/ }),

/***/ 51498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulProvider/ContentfulProvider.js
var ContentfulProvider = __webpack_require__(26518);
// EXTERNAL MODULE: ./node_modules/@pcln/feature-components/dist/esm/FeatureProvider/FeatureProvider.js
var FeatureProvider = __webpack_require__(21643);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 21 modules
var Layout = __webpack_require__(32947);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(1377);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(22091);
;// CONCATENATED MODULE: ./src/components/Home/index.tsx






var HomeDesktop = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1555), __webpack_require__.e(7223), __webpack_require__.e(9379), __webpack_require__.e(3467), __webpack_require__.e(9029), __webpack_require__.e(6220), __webpack_require__.e(4176), __webpack_require__.e(3885), __webpack_require__.e(4674), __webpack_require__.e(370), __webpack_require__.e(9754), __webpack_require__.e(1385), __webpack_require__.e(1232), __webpack_require__.e(2365), __webpack_require__.e(8935), __webpack_require__.e(8243), __webpack_require__.e(49), __webpack_require__.e(2230), __webpack_require__.e(2420), __webpack_require__.e(4566), __webpack_require__.e(65), __webpack_require__.e(4350)]).then(__webpack_require__.bind(__webpack_require__, 64350));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64350)
            ];
        }
    }
});
var HomeMobile = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1555), __webpack_require__.e(7223), __webpack_require__.e(9379), __webpack_require__.e(9029), __webpack_require__.e(6220), __webpack_require__.e(3885), __webpack_require__.e(9754), __webpack_require__.e(1232), __webpack_require__.e(2365), __webpack_require__.e(8935), __webpack_require__.e(2420), __webpack_require__.e(4566), __webpack_require__.e(9529), __webpack_require__.e(7873)]).then(__webpack_require__.bind(__webpack_require__, 67873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67873)
            ];
        }
    }
});
function Home() {
    (0,useSeti/* default */.Z)('AA_HOMEPAGE') // AA Test: Unconditional firing and no visual changes
    ;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDesktop, {})
    });
};

// EXTERNAL MODULE: ./src/components/AppBanner/index.tsx
var AppBanner = __webpack_require__(29397);
// EXTERNAL MODULE: ./src/components/AppBanner/constants.ts
var constants = __webpack_require__(65720);
// EXTERNAL MODULE: ./src/constants/products.ts
var products = __webpack_require__(85968);
// EXTERNAL MODULE: ./src/components/AppBanner/utils.ts
var utils = __webpack_require__(13326);
;// CONCATENATED MODULE: ./src/pages/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var appBannerValues = constants/* default */.Z[products/* HOME_PRODUCT_TYPE */.Wn];
var Homepage = function(param) {
    var headerHTML = param.headerHTML, footerHTML = param.footerHTML, bootstrapData = param.bootstrapData;
    var query = (0,router.useRouter)().query;
    var shouldShowAppBanner = !(0,utils/* shouldHideAppBanner */.Cx)(bootstrapData, query);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureProvider/* default */.ZP, {
        features: bootstrapData.featureToggles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentfulProvider/* default */.Z, {
            contentful: bootstrapData.contentful,
            children: [
                shouldShowAppBanner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBanner["default"], _objectSpread({}, (0,AppBanner.getPropsForAppBanner)(bootstrapData), appBannerValues)) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout["default"], {
                    headerHTML: headerHTML,
                    footerHTML: footerHTML,
                    partner: bootstrapData.partner || null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {})
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Homepage);


/***/ }),

/***/ 27781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLoadedInAppView; }
/* harmony export */ });
function isLoadedInAppView(query) {
    var NEGOTIATORAPP = query.NEGOTIATORAPP, negotiatorapp = query.negotiatorapp;
    return NEGOTIATORAPP !== undefined || negotiatorapp !== undefined;
};


/***/ }),

/***/ 32680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6L8 16.6z"
  }));
};

var SvgChevronRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "ChevronRight__SvgChevronRight",
  componentId: "sc-189tolx-0"
})(["outline:none;"]);
SvgChevronRight.isIcon = true;
SvgChevronRight.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRight);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9126,6592,5741,766,7771,4001,7615,2130,2947,9774,2888,179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);